import { container } from "../../../material-kit-react.jsx";

const tabsStyle = {
  section: {
    background: "#EEEEEE",
    padding: "70px 0"
  },
  container,
  textCenter: {
    textAlign: "center"
  }
};

export default tabsStyle;
